/*
 * SC plan selector (PDP)
 * Drives the three plan cards in sections/pdp-hero.liquid and writes the
 * choice into the product form's hidden inputs. sc-pdp-atc.js then posts
 * the whole form to /cart/add.js, so nothing else needs to change.
 *
 *   a  2-month supply   qty 2, every 2 months   (switch on: Supply for two, qty 2, every month)
 *   b  1-month supply   qty 1, every month
 *   c  One-time         qty 1 (switch on: 2), no selling plan
 */
(function () {
  var root = document.getElementById('sc-plans');
  var form = document.getElementById('pdp-hero-form');
  if (!root || !form) return;

  var d = root.dataset;
  var P1 = d.planOneMonth, P2 = d.planTwoMonth;
  if (!P1 || !P2) {
    console.error('[SC plan selector] Missing selling plan IDs on #sc-plans');
    return;
  }
  var q = function (sel) { return root.querySelector(sel); };

  var sellingPlan = document.getElementById('pdp-selling-plan');
  var qtyInput = document.getElementById('pdp-form-qty');
  var atcBtn = document.getElementById('pdp-atc-btn');

  var forTwo = q('[data-for-two]');
  var twoBoxes = q('[data-two-boxes]');

  // Read state from the controls so a restored page (back button) stays consistent.
  function readState() {
    var checked = root.querySelector('input[name="sc_plan"]:checked');
    return {
      plan: checked ? checked.value : 'a',
      forTwo: !!(forTwo && forTwo.checked),
      onceQty: twoBoxes && twoBoxes.checked ? 2 : 1
    };
  }

  function setText(sel, text) {
    var el = q(sel);
    if (el) el.textContent = text;
  }

  function render() {
    var s = readState();

    root.querySelectorAll('.sc-plan').forEach(function (card) {
      card.classList.toggle('is-selected', card.dataset.plan === s.plan);
    });

    // Card A
    setText('[data-a-title]', s.forTwo ? 'Supply for two' : '2-month supply');
    setText('[data-a-desc]', d.twoSub + (s.forTwo ? ' billed monthly' : ' billed every 2 months'));
    setText('[data-a-check1]', s.forTwo ? '2 boxes every month, a box each' : '2 boxes every 2 months');

    // Card C
    var two = s.onceQty === 2;
    setText('[data-c-desc]', (two ? d.twoOnce : d.oneBilled) + ' billed once');
    setText('[data-c-price]', two ? d.twoOnce : d.one);
    var ship = q('[data-c-ship]');
    if (ship) {
      ship.textContent = two ? 'Free shipping' : '+ ' + d.fee + ' shipping';
      ship.classList.toggle('sc-plan__ship--free', two);
    }
    var shipLine = q('[data-c-ship-line]');
    if (shipLine) {
      shipLine.textContent = two ? 'Free shipping on 2 boxes' : 'No free shipping on 1 box';
      shipLine.classList.toggle('is-x', !two);
      shipLine.classList.toggle('is-check', two);
    }

    // What gets added to the cart
    // No line item property is attached, so lines with the same plan merge in
    // the cart (1-month + Supply for two = one line of 3, every month).
    var add = {
      a: { qty: 2, plan: s.forTwo ? P1 : P2 },
      b: { qty: 1, plan: P1 },
      c: { qty: s.onceQty, plan: '' }
    }[s.plan] || { qty: 2, plan: P2 };

    if (qtyInput) qtyInput.value = add.qty;
    if (sellingPlan) {
      sellingPlan.value = add.plan;
      sellingPlan.disabled = !add.plan; // disabled inputs are left out of FormData, so one-time sends no plan
    }

    // Source of truth for sc-pdp-atc.js. Other scripts (Loop's app embed) can
    // rewrite the form's selling_plan/quantity inputs; they don't touch these.
    form.dataset.scPlan = add.plan;
    form.dataset.scQty = String(add.qty);

    if (atcBtn && !atcBtn.hasAttribute('disabled')) {
      atcBtn.textContent = s.plan === 'c' ? 'Add to cart' : 'Start your ritual';
    }
  }

  root.addEventListener('change', render);

  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-switch-a]')) return;
    var a = root.querySelector('input[name="sc_plan"][value="a"]');
    if (a) a.checked = true;
    if (forTwo) forTwo.checked = false;
    render();
    if (a) a.focus({ preventScroll: true });
  });

  // sc-pdp-atc.js disables and re-enables the button around the request;
  // re-apply the label afterwards in case anything reset it.
  form.addEventListener('submit', function () { setTimeout(render, 0); });

  render();
})();
